import styled from 'styled-components'

export const Main = styled.main<{ mainPadding?: string }>`
  height: 540px;
  overflow-x: hidden;
  overflow-y: scroll;
  padding: ${({ mainPadding }) => mainPadding || '0 30px'};
`
